import * as actions from '../redux/actions';

import CommonService from '../../../../services/commonService';
import KuposInput from '../../../common/KuposInput';
import KuposSelectBox from '../../../common/KuposSelectBox';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const BookingInput = props => {
  const { t } = props;

  const nameChanged = (text, seat) => {
    props.onNameChange(text, seat);
  };

  const last_nameChanged = (text, seat) => {
    props.onLastNameChange(text, seat);
  };
  const inputBlur = (text, seat, inp) => {
    props.onInputBlur(text, seat, inp);
  };
  const countryChanged = (val, seat) => {
    props.onCountryChange(val, seat);
  };
  const idCardChanged = (val, seat) => {
    props.onIdCardChange(val, seat);
  };
  const idCardNumberChanged = (text, seat) => {
    //LIMITIING RUT INPURT SIZE TO 9
    if ((text + '').length > 9) {
      text = (text + '').substr(0, 9);
    }

    props.onIdCardNumberChange(text, seat);
  };

  const seatInputs = (seat, i) => {
    let passengerDetails = CommonService.copyObject(props.passengerDetails);
    // let filter =
    //   passengerDetails && passengerDetails.length
    //   && passengerDetails.map(it => {
    //     if (it.readOnly) {
    //       return it
    //     }
    //     it.readOnly = false
    //     return it
    //   })

    let passenger =
      passengerDetails &&
      passengerDetails.length &&
      passengerDetails.find(it => seat.number == it.seatNumber);

    let disable = passenger && passenger.readOnly ? true : false;

    console.log('passengerDetails', passengerDetails);
    return (
      <tr key={i} className="passenger-input font10">
        <td className="seat-number-input">
          <div className="kupos-border primary-text bold-text" style={{ cursor: 'default' }}>
            {seat.number}
          </div>
        </td>
        <td className="nationality-input">
          <KuposSelectBox
            options={props.countries}
            selectedOption={passenger ? passenger.nationality : {}}
            onChange={val => countryChanged(val, seat)}
            height={40}
            showAll={true}
            readonly={true}
            t={t}
            marginTop={0.1}
            key={passenger && passenger.nationality && passenger.nationality.value}
            disabled={disable}
          />
        </td>
        <td className="doc-input">
          <KuposSelectBox
            options={props.idCardTypes}
            selectedOption={passenger ? passenger.idCardType : {}}
            onChange={val => idCardChanged(val, seat)}
            height={40}
            showAll={true}
            readonly={true}
            t={t}
            marginTop={0.1}
            key={passenger && passenger.idCardType && passenger.idCardType.value}
            disabled={disable}
          />
        </td>
        <td className="rut-input">
          <KuposInput
            className="kupos-border"
            type="text"
            // placeholder= {t('PASSENGER_DETAILS.DOC_NUMBER')}
            value={passenger ? passenger.idCardNumber : ''}
            onChange={text => idCardNumberChanged(text, seat)}
            onBlur={text => inputBlur(text, seat, 'card_number')}
            error={props.cardNumberError && props.cardNumberError[seat.number] ? true : false}
            errorMessage={
              props.cardNumberError && props.cardNumberError[seat.number]
                ? t(props.cardNumberError[seat.number].message)
                : ''
            }
            disabled={disable}
          />
        </td>
        <td className="name-input">
          <KuposInput
            className="kupos-border"
            type="text"
            // placeholder={t('PASSENGER_DETAILS.NAME')}
            value={passenger ? passenger.name : ''}
            onChange={text => nameChanged(text, seat)}
            onBlur={text => inputBlur(text, seat, 'name')}
            error={props.nameError && props.nameError[seat.number] ? true : false}
            errorMessage={
              props.nameError && props.nameError[seat.number]
                ? t(props.nameError[seat.number].message)
                : ''
            }
            disabled={disable}
          />
        </td>
        <td className="name-input">
          <KuposInput
            className="kupos-border"
            type="text"
            // placeholder={t('PASSENGER_DETAILS.SURNAME')}
            value={passenger ? passenger.last_name : ''}
            onChange={text => last_nameChanged(text, seat)}
            onBlur={text => inputBlur(text, seat, 'last_name')}
            error={props.last_nameError && props.last_nameError[seat.number] ? true : false}
            errorMessage={
              props.last_nameError && props.last_nameError[seat.number]
                ? t(props.last_nameError[seat.number].message)
                : ''
            }
            disabled={disable}
          />
        </td>
      </tr>
    );
  };

  return (
    <div className="pb-payment-details-booking-input">
      <table>
        <tbody>
          <tr className="passenger-input-heading bold-text font10">
            <th className="seat-number-input">
              N<sup>o</sup>{' '}
            </th>
            <th className="nationality-input">{t('PASSENGER_DETAILS.NATIONALITY')}</th>
            <th className="doc-input">{t('PASSENGER_DETAILS.DOCUMENT')}</th>
            <th className="rut-input">{t('PASSENGER_DETAILS.DOC_NUM_DEGREE')}</th>
            <th className="name-input">{t('PASSENGER_DETAILS.NAME')}</th>
            <th className="last_name-input">{t('PASSENGER_DETAILS.SURNAME')}</th>
          </tr>
          {props.selectedSeatsToBook.map((seat, i) => seatInputs(seat, i))}
        </tbody>
      </table>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbPaymentDetails: state.pbPaymentDetails,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookingInput);



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/BookingInput/BookingInput.js